import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ImpersonationStateService } from './impersonation-state.service';
import { ImpersonationPersonModel } from '../models/impersonation-person.model';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AvailableImpersonationPersonModel } from '../models/available-impersonation-person.model';
import { HttpCustomHeaderEnum } from '../../shared/enums/http-custom-header.enum';

@Injectable({
    providedIn: 'root'
})

export class ImpersonationService {

    constructor(
        private router: Router,
        private httpService: HttpClient,
        private impersonationStateService: ImpersonationStateService
    ) { }

    public getImpersonationUserId(): number | null {
        const storedValue = localStorage.getItem(environment.impersonation.impersonationUserIdKey);
        return storedValue !== null ? Number(storedValue) : null;
    }

    public startImpersonation(impersonationUserId: number) {
        localStorage.setItem(environment.impersonation.impersonationUserIdKey, impersonationUserId.toString());
        this.updateActiveImpersonation();
    }

    public endActiveImpersonation(): void {
        localStorage.removeItem(environment.impersonation.impersonationUserIdKey);
        this.updateActiveImpersonation();
    }

    public updateActiveImpersonation(): void {

        var impersonationUserId = this.getImpersonationUserId()

        if (impersonationUserId == null) {
            this.impersonationStateService.activeImpersonationPerson.next(null);
            this.impersonationStateService.activeImpersonationUserId.next(null);
            return;
        }

        this.impersonationStateService.activeImpersonationUserId.next(impersonationUserId);

        this.getImpersonationPersonDetails(impersonationUserId!)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    // Suppress 401: no error handling
                    if (error.status === 401) return of(null);

                    // Let other errors through to subscription's error handler
                    return throwError(() => error);
                })
            )
            .subscribe({
                next: (x) => {
                    this.impersonationStateService.activeImpersonationPerson.next(x);
                }
            })
    }

    public getAvailableImpersonationPersons(): Observable<AvailableImpersonationPersonModel[]> {
        return this.httpService.get<AvailableImpersonationPersonModel[]>(`${environment.api}/Admin/Impersonation/AvailableTrainers`);
    }

    private getImpersonationPersonDetails(personId: number): Observable<ImpersonationPersonModel> {
        const headers = new HttpHeaders({ [HttpCustomHeaderEnum.Skip_Error_Handling]: 'true' });
        return this.httpService.get<ImpersonationPersonModel>(`${environment.api}/Admin/Impersonation/Persons/${personId}/Details`, { headers });
    }
}
